import { number } from "prop-types";
import { forwardRef, memo } from "react";
import { Page } from "react-pdf";

import { PAGE_ID_PREFIX } from "./constants";
import useMarkContentByTerms from "./hooks/useMarkContentByTerms";
import classes from "./PdfPage.module.scss";
import TermDescriptionHoverTooltip from "./TermDescriptionHoverTooltip";

const PdfPage = forwardRef(({ index }, virtualizerRef) => {
  const pageNumber = index + 1;

  // Gotta manually render _After_ cos PDF rendering is slower
  // than the useEffect within this Hook, so no marks will
  // display 'til the onRenderTextLayerSuccess is invoked.
  const { ref, markAllTerms } = useMarkContentByTerms();

  return (
    <div
      className={classes["pdf_page"]}
      data-index={index}
      ref={virtualizerRef}
      id={`${PAGE_ID_PREFIX}${pageNumber}`}
    >
      <Page
        className={classes["pdf_page__pdf"]}
        inputRef={ref}
        pageNumber={pageNumber}
        onRenderTextLayerSuccess={markAllTerms}
      />
      <TermDescriptionHoverTooltip containerRef={ref} />
    </div>
  );
});

PdfPage.displayName = "PdfPage";

PdfPage.propTypes = {
  index: number,
};

export default memo(PdfPage);
